import createDuck from 'common/modules/baseDuck'
import { creators, types } from './actions'
import reducer, { initialState } from './reducer'
import takes from './takes'
import sagas from './sagas'

export default createDuck({
    store: 'router',
    initialState,
}).extend({
    types,
    reducer,
    creators,
    sagas,
    takes,
})

// this API (.push, .replace is needed in sagas)
// the router module exists in landing pages
// when creating the saga, we should be able to manually pass in the methods
